import { Box, Typography } from "@mui/material";
import { StatusChannelEnum } from "@pagesChannel/ChannelManagement/DetailChannel/components/constant";
import { CancelChannel } from "api/Channel/CancelChannel";
import CoreTable from "common/components/forms_context/Table2/CoreTable";
import { useDefaultForm } from "common/hooks/useDefaultForm";
import { usePaginatedFilterUrl } from "common/hooks/usePaginatedFilterUrl";
import { queryKeys } from "helper/react-query";
import { handleTableChange } from "helper/utils";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const HistoryInfo2 = ({ initValue }) => {
  const { t } = useTranslation("uaa");

  const [submitedFormValues, submitFormValues] = useState(initValue);

  const {
    data: historyData,
    totalRecord,
    isFetching,
    defaultPage,
  } = usePaginatedFilterUrl(
    queryKeys.GET_HISTORY_INFO,
    CancelChannel.historyInfo,
    convertPayloadHistory,
    initValue,
    submitedFormValues
  );
  const { page, size } = useDefaultForm(defaultPage);

  const columns = [
    {
      accessorKey: "no",
      header: () => t("header.no"),
      size: 10,
      className: "text-center",
      cell: ({ row: { index } }) => {
        return <>{(page - 1) * size + index + 1}</>;
      },
    },
    {
      accessorKey: "transactionId",
      header: () => t("header.transactionId"),
      className: "text-center",
    },
    {
      accessorKey: "createdTime",
      header: () => t("header.create-time"),
      className: "text-center",
      cell: ({ row: { original } }) => {
        const { createdTime } = original;
        if (createdTime) {
          const [date, time] = createdTime?.split(" ");
          return (
            <>
              <span>{date}</span>
              <br />
              <span>{time}</span>
            </>
          );
        } else {
          return null;
        }
      },
    },
    {
      accessorKey: "requester",
      header: () => t("header.requester"),
      className: "text-center",
    },
    {
      accessorKey: "reasonCancel",
      header: () => t("header.reason-cancel"),
      className: "text-center",
    },
    {
      accessorKey: "approveBy",
      header: () => t("header.approver"),
      className: "text-center",
    },
    {
      accessorKey: "approveTime",
      header: () => t("header.approved-time"),
      className: "text-center",
      cell: ({ row: { original } }) => {
        const { approveTime } = original;
        if (approveTime) {
          const [date, time] = approveTime?.split(" ");
          return (
            <>
              <span>{date}</span>
              <br />
              <span>{time}</span>
            </>
          );
        } else {
          return null;
        }
      },
    },
    {
      accessorKey: "reasonReject",
      header: () => t("header.reason-reject"),
      className: "text-center",
      cell: ({ row: { original } }) => {
        const { transactionState, reasonReject } = original;
        // If transactionState === Cancel reject
        return <>{transactionState == 18 ? reasonReject : null}</>;
      },
    },
    {
      accessorKey: "transactionState",
      header: () => t("header.transaction-state"),
      className: "text-center",
      cell: ({ row: { original } }) => {
        const { transactionState } = original;
        return (
          <>{t(`channel-status.${StatusChannelEnum[transactionState]}`)}</>
        );
      },
    },
  ];

  return (
    <>
      <Box className="my-10">
        <Typography className="mb-8">{t(`header.history-info`)}</Typography>
        <CoreTable
          data={historyData}
          loading={isFetching}
          columns={columns}
          totalItem={totalRecord}
          handleFetchData={(e) => handleTableChange(e)(submitFormValues)}
          pageIndex={page - 1}
          pageSize={size}
          isShowPagination
          fileNameTranslation="uaa"
        />
      </Box>
    </>
  );
};

export default HistoryInfo2;

const convertPayloadHistory = (form) => {
  return {
    ...form,
  };
};
